import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;

export const env = createEnv({
  isServer: typeof window === "undefined",
  skipValidation: process.env.NODE_ENV === "test",
  client: {
    NEXT_PUBLIC_BASE_URL: z.url(),
    NEXT_PUBLIC_SYNC_PRODUCTS_SECRET_TOKEN: APP_ENV === "local" ? z.string().optional() : z.string(),
    NEXT_PUBLIC_API_BASE_URL: z.url(),
    NEXT_PUBLIC_CMS_BASE_URL: z.url(),
    NEXT_PUBLIC_CMS_ASSETS_URL: z.string().min(3),
    NEXT_PUBLIC_CMS_IMAGES_URL: z.string().min(3),
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
    NEXT_PUBLIC_GTAG_ID: z.string().optional(),
    NEXT_PUBLIC_BUILDER_API_KEY: z.string().optional(),
    NEXT_PUBLIC_BRAND: z.string(),
    NEXT_PUBLIC_SITE_NAME: z.string(),
    NEXT_PUBLIC_CURRENCY: z.string(),
    NODE_ENV: z.enum(["development", "test", "production"]),
    NEXT_PUBLIC_APP_ENV: z.enum(["local", "qa", "prod"]),
    NEXT_PUBLIC_ENABLE_BUG_TRACKER: z.preprocess((val) => val === "true", z.boolean().default(false)),
    NEXT_PUBLIC_HS_PORTAL_ID: z.string().optional(),
  },
  runtimeEnv: {
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_SYNC_PRODUCTS_SECRET_TOKEN: process.env.NEXT_PUBLIC_SYNC_PRODUCTS_SECRET_TOKEN,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_CMS_BASE_URL: process.env.NEXT_PUBLIC_CMS_BASE_URL,
    NEXT_PUBLIC_CMS_ASSETS_URL: process.env.NEXT_PUBLIC_CMS_ASSETS_URL,
    NEXT_PUBLIC_CMS_IMAGES_URL: process.env.NEXT_PUBLIC_CMS_IMAGES_URL,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_GTAG_ID: process.env.NEXT_PUBLIC_GTAG_ID,
    NEXT_PUBLIC_BUILDER_API_KEY: process.env.NEXT_PUBLIC_BUILDER_API_KEY,
    NEXT_PUBLIC_BRAND: process.env.NEXT_PUBLIC_BRAND,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NEXT_PUBLIC_CURRENCY: process.env.NEXT_PUBLIC_CURRENCY,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_ENABLE_BUG_TRACKER: process.env.NEXT_PUBLIC_ENABLE_BUG_TRACKER,
    NEXT_PUBLIC_HS_PORTAL_ID: process.env.NEXT_PUBLIC_HS_PORTAL_ID,
  },
});
